module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "overflow": "auto"
    }
  }, [(_vm.CelotnaNaloga.text && _vm.$options.filters.pickTranslation(_vm.CelotnaNaloga.text) !== '') ? _c('h4', {
    staticClass: "exerciseTitle"
  }, [_c('div', {
    staticClass: "pull-left"
  }, [_c('div', {
    staticClass: "exercise-body",
    domProps: {
      "innerHTML": _vm._s(this.$options.filters.pickTranslation(_vm.CelotnaNaloga.text))
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]) : _vm._e()])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-0ce09d04", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0ce09d04"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/exercises/ExerciseTitle.vue
// module id = 1379
// module chunks = 1